import React, { ReactElement, useState, useEffect } from "react";
import InfoIcon from '@mui/icons-material/Info';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface IHintState {
    Icon: React.ReactNode | null;
    color: string;
}

export const useHint = (type: string) => {
    const [hintState, setHintState] = useState<IHintState>({
        color: "",
        Icon: null
    });

    useEffect(() => {
        switch (type) {
            case "default":
                setHintState((prevState) => ({
                    ...prevState,
                    color: "rgba(0, 0, 0, 0.7)"
                }));
                break;
            case "info":
                setHintState((prevState) => ({
                    Icon: <InfoIcon fontSize="small" color="primary" />,
                    color: "#2F79E9"
                }));
    
                break;
            case "error":
                setHintState((prevState) => ({
                    Icon: <CancelIcon fontSize="small" color="error" />,
                    color: "#ED3E3E"
                }));
                break;
            case "success":
                setHintState((prevState) => ({
                    Icon: <CheckCircleIcon fontSize="small" color="success" />,
                    color: "#25C176"
                }));
                break;
        }
    }, [])

    return {
        hintState
    }
}   